import { Component, OnInit } from "@angular/core";

import { Company } from "src/app/ui/models/domains/pbm/companies/company";
import { TopTenProductsIndicatorData } from "src/app/ui/models/domains/pbm/indicators/top-ten-indicator-data";
import { TopTenProductsIndicatorDataStrategy } from "src/app/ui/pages/home/indicator-data-strategies";
import { IndicatorMediator } from "src/app/ui/services/pbm/indicator-mediator";
import { IndicatorService } from "src/app/ui/services/pbm/indicator.service";

@Component({
  selector: "top-ten-products-indicator",
  templateUrl: "./top-ten-products-indicator.component.html",
  styleUrls: ["./top-ten-products-indicator.component.scss"],
})
export class TopTenProductsIndicatorComponent implements OnInit {
  public topTenProductsData: TopTenProductsIndicatorData;
  public isLoading: boolean = true;

  constructor(private indicatorService: IndicatorService, private indicatorMediator: IndicatorMediator) {}

  async ngOnInit() {
    this.topTenProductsData = (await this.indicatorMediator.getIndicatorData(new TopTenProductsIndicatorDataStrategy())) as TopTenProductsIndicatorData;
    this.isLoading = false;
  }

  public async onFilterData(company: Company) {
    this.isLoading = true;
    if (company) this.topTenProductsData = await this.indicatorService.getTopTenProductsData([company.getFiscalNumber()]);
    else this.topTenProductsData = await this.indicatorService.getTopTenProductsData();
    this.isLoading = false;
  }

  public getTotal(): string {
    return this.topTenProductsData && this.topTenProductsData.getTotal();
  }

  public getTopTenProductsList() {
    return this.topTenProductsData && this.topTenProductsData.getItems();
  }

  public hasTopTenProductsData(): boolean {
    return !!this.topTenProductsData && !!this.topTenProductsData.getItems().length;
  }

  public trackByFn = (index: number, item: any) => item.id;
}
